export const Menu = `

    import { Menu } from '@headlessui/react'


    function classNames(...classes: any) {
        return classes.filter(Boolean).join(' ')
    }

    const MenuExample = () => {
        return (
            <Menu as="div" className="relative inline-block text-left">
                <Menu.Button className="inline-flex py-2 px-4 bg-gray-100 hover:bg-gray-200 text-primary font-bold text-center rounded cursor-pointer align-middle focus:outline-none focus:ring-offset-2 focus:ring-2 ring-gray-400">
                Options
                </Menu.Button>
                <Menu.Items className="origin-top-right absolute left-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="py-1">
                    <Menu.Item>
                    {({ active }) => (
                        <a
                        href="#"
                        className={classNames(
                            active ? 'bg-primary text-white' : 'text-gray-700',
                            'block px-4 py-2 text-sm'
                        )}
                        >
                        Option
                        </a>
                    )}
                    </Menu.Item>
                    <form method="POST" action="#">
                    <Menu.Item>
                        {({ active }) => (
                        <button
                            type="submit"
                            className={classNames(
                            active ? 'bg-primary text-white' : 'text-gray-700',
                            'block w-full text-left px-4 py-2 text-sm'
                            )}
                        >
                            Sign out
                        </button>
                        )}
                    </Menu.Item>
                    </form>
                </div>
                </Menu.Items>
            </Menu>
        )
    }
    export default MenuExample
`